import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import { RootState } from './types'
import { loading } from './loading'
import { error } from './error'
import { latestPaymentRecords } from './latestPaymentRecords'
import { enums } from './enums'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  modules: {
    loading,
    error,
    latestPaymentRecords,
    enums,
  },
}

export default new Vuex.Store<RootState>(store)
